import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private impersonationFinished$ = new BehaviorSubject<boolean>(false);
  private impersonatedUserEmail$ = new BehaviorSubject<string | null>(null);

  impersonationFinishedObs = this.impersonationFinished$.asObservable();
  impersonatedUserEmailObs = this.impersonatedUserEmail$.asObservable();

  constructor() {
    const savedEmail = localStorage.getItem('impersonated_email');
    if (savedEmail) {
      this.impersonatedUserEmail$.next(savedEmail);
    }
  }

  notifyFinished() {
    this.impersonationFinished$.next(true);
  }

  setImpersonatedUser(email: string) {
    localStorage.setItem('impersonated_email', email);
    this.impersonatedUserEmail$.next(email);
  }

  clearImpersonation() {
    localStorage.clear();
    this.impersonatedUserEmail$.next(null);
    this.impersonationFinished$.next(true);
  }
}
